import { OptionType } from '../enumerators/messages.enum';

export class DialogOption {
    public title: string = "";
    public icon: string = '';
    public value: number = 0;
    public type: OptionType = OptionType.Positive;
    public class: string = "";

    constructor(init?: Partial<DialogOption>) {
        Object.assign(this, init);
    }
}